// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"slideshow_slideshow__1RhZd","imageHolderDiv":"slideshow_imageHolderDiv__3feU_","appear":"slideshow_appear__1zoEU","controller":"slideshow_controller__KO9QJ"};